var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('div', {
    staticClass: "my-3 my-lg-6"
  }, [_c('v-row', {
    staticClass: "ma-n1 ma-lg-n3",
    attrs: {
      "justify": "center"
    }
  }, [_vm.isAndroidBrowser ? _c('v-col', {
    staticClass: "pa-1 pa-lg-3",
    attrs: {
      "cols": _vm.$vuetify.breakpoint.mobile ? '6' : 'auto'
    }
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.deahanbooks.salerbook",
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/offerwall/download-google.svg"
    }
  })], 1)]) : _vm._e(), _vm.isIOSBrowser ? _c('v-col', {
    staticClass: "pa-1 pa-lg-3",
    attrs: {
      "cols": _vm.$vuetify.breakpoint.mobile ? '6' : 'auto'
    }
  }, [_c('a', {
    attrs: {
      "href": "https://apps.apple.com/kr/app/id1637558375",
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/offerwall/download-apple.svg"
    }
  })], 1)]) : _vm._e()], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }